import { toHome } from '@/commons';
import { Button, Result } from 'antd-mobile';
import { useTranslation } from 'react-i18next';
import s from './style.module.less';

export function Error404() {
  const { t } = useTranslation('component');
  return (
    <div className={s.root}>
      <Result description={t('error_404_subtitle')} status="info" title="404" />
      <div className={s.action}>
        <Button color="primary" onClick={() => toHome()}>
          {t('back_home')}
        </Button>
      </div>
    </div>
  );
}
